angular.module('app').component('adminButton', {
    templateUrl: 'events/components/button.html',
    bindings: {
        ariaExpanded: '<?buttonAriaExpanded',
        ariaLabel: '@?buttonAriaLabel',
        buttonForm: '@?',
        buttonType: '@?',
        disabled: '<?',
        href: '@?',
        icon: '@?',
        rel: '@?',
        size: '@?',
        target: '@?',
        text: '@?',
        variant: '@?',
        onClick: '&'
    },
    controller: function() {
        var main = this;

        main.handleClick = function(event) {
            main.onClick({$event: event});
        };
    }
});
